export enum UserMessagesEnum {
  //BE Env messages
  BaseUrlIsSetup = 'Base URL has been changed successfully.',
  BaseUrlIsRestored = 'Base URL has been restored to default.',
}
